import React from 'react';
import PropTypes from 'prop-types';
import { CardTag, CardImageContainer, CardContainer, CardHeading, CardSubheading, CardPrice } from "./styles";

const WaysBigCard = ({ img, heading, price }) => (
  <CardTag>
    <CardImageContainer>
      <img src={img} alt={heading} />
    </CardImageContainer>
    <CardContainer>
      <CardSubheading>Most popular</CardSubheading>
      <CardHeading>{heading}</CardHeading>
      <CardPrice htmlType="button" btnType="primary"><span>From ${price}</span>/guest</CardPrice>
    </CardContainer>
  </CardTag>
);

WaysBigCard.propTypes = {
  img: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired
};

export default WaysBigCard;
